/**
 * Converte o payload flat do backend (cliente_nome, troco_precisa,
 * endereco_rua, tipo_entrega...) pra estrutura aninhada esperada pelo modal
 * de detalhes do pedido em Pedidos.js e pelo PedidoViewModal do relatório
 * de avaliações.
 *
 * Backend retorna formato flat (PedidoResponse em api/v1/pedidos/schemas.py).
 * Esse helper centraliza a normalização pra evitar drift entre os 2 callers.
 */
export function mapPedidoFromApi(p) {
  return {
    id: p.id,
    codigo: p.codigo,
    cliente: {
      id: p.cliente_id,
      nome: p.cliente_nome,
      telefone: p.cliente_telefone,
      email: p.cliente_email,
    },
    items: p.items || [],
    total: p.total,
    status: p.status,
    formaPagamento: p.forma_pagamento,
    pagamentos: p.pagamentos || null,
    // Uma linha por forma já com nome e valor (servidor) — é o que a tela mostra.
    pagamentoPartes: p.pagamento_partes || null,
    senha_balcao: p.senha_balcao || null,
    troco: p.troco_precisa ? { precisa: p.troco_precisa, valor: p.troco_valor } : null,
    tipoEntrega: p.tipo_entrega,
    endereco: p.endereco_rua
      ? {
          label: p.endereco_label,
          endereco: p.endereco_rua,
          numero: p.endereco_numero,
          complemento: p.endereco_complemento,
          bairro: p.endereco_bairro,
          cep: p.endereco_cep,
        }
      : null,
    modulo: p.modulo || (p.mesa_id ? "Mesas" : p.modulo),
    // "cleo" = pedido anotado pela CLEO na conversa do WhatsApp (selo CLEO); o módulo continua Cardápio.
    origem: p.origem || null,
    mesa_id: p.mesa_id,
    mesa_opened_at: p.mesa_opened_at,
    mesa_closed_at: p.mesa_closed_at,
    observacao: p.observacao,
    created_at: p.created_at,
    tempo_aceite_min: p.tempo_aceite_min,
    tempo_aceite_seg: p.tempo_aceite_seg,
    tempo_producao_min: p.tempo_producao_min,
    tempo_producao_seg: p.tempo_producao_seg,
    tempo_pronto_min: p.tempo_pronto_min,
    tempo_pronto_seg: p.tempo_pronto_seg,
    tempo_na_bag_min: p.tempo_na_bag_min,
    tempo_na_bag_seg: p.tempo_na_bag_seg,
    tempo_em_rota_min: p.tempo_em_rota_min,
    tempo_em_rota_seg: p.tempo_em_rota_seg,
    tempo_ate_retirar_min: p.tempo_ate_retirar_min,
    tempo_ate_retirar_seg: p.tempo_ate_retirar_seg,
    tempo_total_min: p.tempo_total_min,
    tempo_total_seg: p.tempo_total_seg,
    ts_producao: p.ts_producao,
    ts_pronto: p.ts_pronto,
    ts_na_bag: p.ts_na_bag,
    ts_em_rota: p.ts_em_rota,
    ts_concluido: p.ts_concluido,
    entregador_id: p.entregador_id,
    entregador_nome: p.entregador_nome,
    caixa_id: p.caixa_id,
    review_rating_avg: p.review_rating_avg,
    review_ratings: p.review_ratings,
    review_comment: p.review_comment,
    review_submitted_at: p.review_submitted_at,
    scheduled_at: p.scheduled_at || null,
    // Reabertura (Vendas → Pedidos): selo "Reaberto"/"Editado"
    reaberto_em: p.reaberto_em || null,
    reaberto_por: p.reaberto_por || null,
    reaberto_vezes: p.reaberto_vezes || 0,
    // De qual campanha o pedido veio (Meta, link de divulgação, SMS, ligação):
    // {canal, rotulo, nome, campaign_id, adset_id, ad_id} ou null.
    origem_campanha: p.origem_campanha || null,
  };
}
